import React, { Component } from 'react';
import { Col, Container, Row } from '../../components/Grid';
import './NoMatch.css';
import { Fade } from 'react-awesome-reveal';
import UnifiedNav from '../../components/Nav/UnifiedNav';
import footprintIcon from 'icons/footprint.svg';

const FOOTPRINT_DELAY = 600;
const SECOND_TRAIL_EXTRA_DELAY = 4900; // Extra delay for second trail
const STEPS_PER_TRAIL = 8;
const MIN_FOOTPRINT_SIZE = 20;
const MAX_FOOTPRINT_SIZE = 40;

// Shift the second trail downward and to the LEFT (post-generation)
const SHIFT_LEFT = -20;  // Negative means leftward
const SHIFT_TOP = 20;    // Positive means downward

const FIRST_TRAIL_SHIFT_LEFT = -50;
const FIRST_TRAIL_SHIFT_TOP = 40;

// The same Bézier-like or sinusoidal curve
const walkingPath = (t) => {
  const x = 15 + t * 30 + 5 * Math.sin(2 * Math.PI * t);
  const y = 95 - 40 * t + 5 * Math.cos(3 * Math.PI * t);
  return { x, y };
};

class NoMatch extends Component {
  messageDisplay() {
    if (window.location.pathname === '/unauthorized') {
      return {
        title: 'Unauthorized',
        message: "You've gone off the trail... Please Login or Sign Up",
      };
    } else {
      return {
        title: '404 Page Not Found',
        message: "Oh, deer... Looks like you've made a wrong turn!",
      };
    }
  }

  generateFootprintTrail(startT, endT, steps) {
    const footprints = [];
    const stepSize = (endT - startT) / steps;

    let lastY = null;

    for (let i = 0; i < steps; i++) {
      const t = startT + i * stepSize;
      const { x, y } = walkingPath(t);

      // Sine-based offset for natural variation
      const offset = Math.sin(i / 2) * 0.05;

      // Gradual footprint size change
      const footprintSize = MAX_FOOTPRINT_SIZE - 
        (i / (steps - 1)) * (MAX_FOOTPRINT_SIZE - MIN_FOOTPRINT_SIZE);

      footprints.push({
        top: `${y + offset}%`,
        left: `${x}%`,
        size: footprintSize,
        isLeft: i % 2 === 0,
      });

      // Track final y if needed
      if (i === steps - 1) {
        lastY = y + offset;
      }
    }
    return { footprints, lastY };
  }

  render() {
    const message = this.messageDisplay();

    // --- FIRST TRAIL---
    const { footprints: unshiftedFirstTrail } = this.generateFootprintTrail(0.7, 1.7, STEPS_PER_TRAIL);

    // --- SECOND TRAIL---
    const { footprints: unshiftedSecondTrail } = this.generateFootprintTrail(1.2, 2.2, STEPS_PER_TRAIL);
    

    const firstTrail = unshiftedSecondTrail.map(fp => {
      const numericTop = parseFloat(fp.top);
      const numericLeft = parseFloat(fp.left);
      return {
        ...fp,
        top: `${numericTop + FIRST_TRAIL_SHIFT_TOP}%`,
        left: `${numericLeft + FIRST_TRAIL_SHIFT_LEFT}%`,
      };
    });
    // --- POST-TRANSLATION for second trail (down & left) ---
    const secondTrail = unshiftedSecondTrail.map(fp => {
      const numericTop = parseFloat(fp.top);
      const numericLeft = parseFloat(fp.left);
      return {
        ...fp,
        top: `${numericTop + SHIFT_TOP}%`,
        left: `${numericLeft + SHIFT_LEFT}%`,
      };
    });

    return (
      <React.Fragment>
        {/* Use the UnifiedNav component */}
        <UnifiedNav />
        
        <Container fluid className="nomatch-jumbotron">
          {/* FIRST TRAIL (no translation) */}
          <div className="footprint-container">
            {firstTrail.map((position, index) => (
              <Fade key={`trail1-${index}`} delay={FOOTPRINT_DELAY * (index + 1)}>
                <img
                  width={`${position.size}px`}
                  className="footprint"
                  src={footprintIcon}
                  alt="deer footprint"
                  style={{
                    position: 'absolute',
                    top: position.top,
                    left: position.left,
                    transform: position.isLeft ? 'rotate(15deg)' : 'rotate(-15deg)',
                  }}
                />
              </Fade>
            ))}
          </div>

          <Row>
            <Col className="ml-5 mt-4 nomatch-message">
              <h1 className="display-4 font-weight-bold">{message.title}</h1>
              <h4 className="font-italic">{message.message}</h4>
              <p className="mt-3">
                Maybe one of the links at the top of the page will help?
              </p>
            </Col>
          </Row>

          {/* SECOND TRAIL (translated downward & to the left) */}
          <div className="footprint-container">
            {secondTrail.map((position, index) => (
              <Fade
                key={`trail2-${index}`}
                delay={SECOND_TRAIL_EXTRA_DELAY + FOOTPRINT_DELAY * (index + 1)}
              >
                <img
                  width={`${position.size}px`}
                  className="footprint"
                  src={footprintIcon}
                  alt="deer footprint"
                  style={{
                    position: 'absolute',
                    top: position.top,
                    left: position.left,
                    transform: position.isLeft ? 'rotate(15deg)' : 'rotate(-15deg)',
                  }}
                />
              </Fade>
            ))}
          </div>
        </Container>
      </React.Fragment>
    );
  }
}

export default NoMatch;
